import { apiService } from "api/apiService";
import type {
  ClassroomStudentResource,
  MyLessongroupsShow200,
  MyLessongroupsStudents200,
} from "api/generated";
import type { ClassroomLessonClass, ClassroomStudent } from "classroom/types";
import { classroomStudentFromDto, lessonClassFromDto } from "classroom/mappers";

export const fetchLessonClass = async (
  scheduleId: string,
  signal?: AbortSignal,
): Promise<ClassroomLessonClass> => {
  const url = `/api/my-lessongroups/${encodeURIComponent(scheduleId)}`;

  const { data } = await apiService.get<MyLessongroupsShow200>(url, { signal });

  return lessonClassFromDto(data.data);
};

export const fetchLessonClassStudents = async (
  scheduleId: string,
  search: string | null = null,
  signal?: AbortSignal,
): Promise<ClassroomStudent[]> => {
  const url = `/api/my-lessongroups/${encodeURIComponent(scheduleId)}/students`;
  const params = search !== null && search.length > 0 ? { search } : {};

  const { data } = await apiService.get<MyLessongroupsStudents200>(url, {
    params,
    signal,
  });

  return data.data.map((studentData: ClassroomStudentResource) =>
    classroomStudentFromDto(studentData),
  );
};
